<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
      :page-detail="detailPage"
    />
    <carrier-generator-modal
      :label="this.$gettext('GENERATOR')"
      :generator-id="generator"
      :generator-form="generatorForm"
      :show="show"
      @hide="() => this.show = false"
      @editGenerator="editGenerator"
    />
    <detail-modal
      v-if="generatorDetail.show"
      ref="generator-detail"
      :show="generatorDetail.show"
      :detail="true"
      v-bind="generatorDetail"
      @input="(show) => (generatorDetail.show = show)"
      @action-button="openDetailDocumentModal"
      :label="this.$gettext('GENERATOR')"
    />
    <detail-modal
      v-if="documentDetail.show"
      ref="document-detail"
      :show="documentDetail.show"
      :detail="true"
      v-bind="documentDetail"
      @input="(show) => (documentDetail.show = show)"
      @action-button="actionButtonUpdate"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import CarrierPage from './CarrierPage'
import CarrierDetailPage from './CarrierDetailPage'
import GeneratorPage from 'src/modules/generator/generator/GeneratorPage.vue'
import CarrierGeneratorModal from './CarrierGeneratorModal.vue'
import { repository } from 'jtech'

const { CrudLayout, pageDetail, modal } = JtCrud

@Component({
  name: 'Carrier',
  components: {
    CrudLayout,
    CarrierPage,
    CarrierDetailPage,
    GeneratorPage,
    'detail-modal': modal,
    CarrierGeneratorModal
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Carrier extends Vue {
  show = false
  generator = null
  name = null
  isShowGenerator = false
  generatorForm = null
  action = null
  flModal = false
  documentDetail = {
    show: false
  }

  generatorDetail = {
    show: false
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return CarrierPage
  }

  get detailPage () {
    return CarrierDetailPage
  }

  mounted () {
    this.$refs.crudLayout.onButton('btGravar', this.btGravar)
    this.$refs.crudLayout.onButton('icAlterarComposicaoGenerator', this.showGeneratorForm)
    this.$refs.crudLayout.onButton('icDetalharComposicaoGenerator', this.detalharGenerator)
  }

  async openDetailDocumentModal (button, params) {
    const forms = await repository.resolve('generatorDocument.detalharDocument', { id: params.id })
    this.documentDetail = {
      show: true,
      forms: forms,
      label: button.label,
      params: params
    }
  }

  async btGravar ({ button, params, page, controller }) {
    await repository.create(button.action, params)
    if (page.limparForm) page.limparForm()
    page.forms[0].dadosForm = { carrierVehicles: [] }
  }

  async detalharDocument ({ button, params, page, controller }) {
    const forms = await repository.resolve(button.action, params)
    this.pageDialog = {
      page: pageDetail,
      name: forms[0].label,
      params: params,
      forms: forms,
      parent: page
    }
    this.flModal = true
  }

  async showGeneratorForm ({ button, params }) {
    this.generator = params.id
    const action = this.isAddNewButtonClicked ? 'generator.gravar' : 'generator.alterar'
    this.generatorForm = await repository.resolve(action, params)
    if (this.generatorForm) {
      this.show = true
    }
    this.isAddNewButtonClicked = false
  }

  async editGenerator (button, params, page) {
    if (button.action !== 'generator.gravar') {
      await repository.update(button.action, {
        id: this.generator,
        ...params
      })
    } else {
      await repository.create(button.action, {
        id: this.generator,
        ...params
      })
    }
    this.show = false
  }

  async detalharGenerator ({ button, params, page, controller }) {
    const forms = await repository.resolve('generator.detalhar', { id: params.id })
    this.generatorDetail = {
      show: true,
      params: params,
      forms: forms
    }
  }
}
export default Carrier
</script>
<style lang="stylus" scoped></style>
